import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { dispatch } from 'store'
import { viewMenu } from 'images'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://res.cloudinary.com/codefusiontech/image/upload/v1697018147/twinkleweb/New_Price_of_Oct_2023_v4.pdf`}
              target="_blank"
            >
              <CFView hover>
                <CFImage src={viewMenu} w="95%" maxWidth="320px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://res.cloudinary.com/codefusiontech/image/upload/v1697018147/twinkleweb/New_Price_of_Oct_2023_v4.pdf`}
              target="_blank"
            >
              <CFView hover>
                <CFImage src={viewMenu} w="32vw" maxWidth="300px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
